import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function PatchIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 26 26" {...props}>
      <path d="M5.77778 0C4.18456 0 2.88889 1.1661 2.88889 2.6V3.9H1.44444C0.647111 3.9 0 4.4824 0 5.2C0 5.9176 0.647111 6.5 1.44444 6.5H2.88889V9.1H1.44444C0.647111 9.1 0 9.6824 0 10.4C0 11.1176 0.647111 11.7 1.44444 11.7H2.88889V14.3H1.44444C0.647111 14.3 0 14.8824 0 15.6C0 16.3176 0.647111 16.9 1.44444 16.9H2.88889V19.5H1.44444C0.647111 19.5 0 20.0824 0 20.8C0 21.5176 0.647111 22.1 1.44444 22.1H2.88889V23.4C2.88889 24.8339 4.18456 26 5.77778 26H23.1111C24.7043 26 26 24.8339 26 23.4V2.6C26 1.1661 24.7043 0 23.1111 0H5.77778ZM8.66667 5.2H20.2222V9.1H8.66667V5.2ZM8.66667 11.7H20.2222V14.3H8.66667V11.7ZM8.66667 16.9H20.2222V19.5H8.66667V16.9Z" />
    </SvgIcon>
  );
}
